<template>
	<Row type="container" id="body" class="bg-white rounded mt-3 shadow min-h-screen">

		<Modal
			:text="modalText"
			id="modal_show"
		/>

		<ModalAddCustomer
			:model-form="modelFormCustomer"
			:id="'customer_add'"
			:text="'customer.add'"
			@chooseCustomer="chooseNewCustomer"
		/>

		<Modal
			:text="modalText"
			id="modal_router"
			:on-ok-pressed="goNext"
			:is-ok-only="false"
			ok-text="yes"
			cancel-text="no"
		/>

		<Modal
			:text="modalText"
			id="epos_warning"
			:on-ok-pressed="proceedSale"
			:is-ok-only="false"
			ok-text="yes"
			cancel-text="no"
		/>

		<b-modal id="epos_cannot_send_all" :ok-title="$t('yes')" :cancel-title="$t('no')" @ok="proceedSale">
			<!-- Modal body -->
			<div>
				{{ $t('sale.integrationWarningCanSend') }}
			</div>
			<div v-for="(name, index) of productsWithoutICPS" :key="index" class="mt-3 font-weight-bold">
				{{ name }}
			</div>
			<div class="mt-2 d-flex justify-content-center">
				{{ $t('sale.confirm') }}
			</div>
		</b-modal>

		<b-modal id="epos_print_sale" size="xl" :title="$t('printView.printCheck')" hide-footer>
			<!-- Modal body -->
			<div v-if="getEpos.paycheck" id="epos_receipt">

			</div>
		</b-modal>

        <b-modal id="pay-from-cashback-modal" :title="$t('customer.cashback.payFromCashback')" :ok-title="$t('pay')" :cancel-title="$t('goBack')" @ok="payFromCashback" :hide-footer="errors.cashback !== null">
            <!-- Modal body -->
            <div class="grid grid-cols-2 gap-6 text-gray-700" v-if="modelForm.customerId">
                <div>
                    {{ $t('customer.title') }}: {{ getCustomerName(findCustomerById(modelForm.customerId)) }}
                </div>
                <div v-if="!getUserCompany.isTaxInPrice">
                    {{ $t('kpi.saleSum') }}: {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, modelForm.payedAmount) }}
                </div>
                <div v-else>
                    {{ $t('kpi.saleSum') }}: {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, totalPrice) }}
                </div>
            </div>

            <div class="grid grid-cols-1 mt-5" v-if="modelForm.customerId">
                <template v-if="findCustomerById(modelForm.customerId).hasCard">
                    <div class="text-2xl text-gray-700 text-center" v-if="parseFloat(findCustomerById(modelForm.customerId).cashbackCard.cashbackAmount) < 1">
                        {{ $t('customer.cashback.notHaveCashback') }}
                    </div>
                </template>
                <template v-else>
                    <div class="text-xl text-gray-600 text-center">
                        {{ $t('customer.cashback.notHaveCashbackCard') }}
                    </div>
                </template>
            </div>

            <div class="grid grid-cols-1 text-gray-700" v-if="modelForm.customerId">
                <template v-if="findCustomerById(modelForm.customerId).hasCard">
                    <div v-if="parseFloat(findCustomerById(modelForm.customerId).cashbackCard.cashbackAmount) > 1">
                        {{ $t('customer.cashback.amount') }}:
                        <template v-if="findCustomerById(modelForm.customerId).hasCard">
                            {{ showCurrencyById(findCustomerById(modelForm.customerId).cashbackCard.currency.id, findCustomerById(modelForm.customerId).cashbackCard.cashbackAmount) }}
                        </template>
                        <template v-else>
                            0
                        </template>
                    </div>
                </template>
            </div>

            <div class="grid grid-cols-1 mb-4" v-if="modelForm.customerId">
                <template v-if="findCustomerById(modelForm.customerId).hasCard">
                    <div class="position-relative pl-0 mt-4 mx-3" v-if="parseFloat(findCustomerById(modelForm.customerId).cashbackCard.cashbackAmount) > 1">
                        <div
                            class="font-bold text-sm bg-white px-1 text-red-400 z-30 position-absolute bottom-9 ml-2">
                            {{ $t('productPurchase.paymentAmount') }}
                        </div>
                        <InputBox
                            class="px-0 h-11 border-red-400"
                            model-name="cashback"
                            :model-form="modelForm"
                            :errors="errors"
                            :limit="parseInt(findCustomerById(modelForm.customerId).cashbackCard.cashbackAmount)"
                            check-to-model="modelNotGreater"
                        />
                    </div>
                </template>
            </div>

            <div class="grid grid-cols-1" v-if="modelForm.customerId && errors.cashback === null">
                <template v-if="findCustomerById(modelForm.customerId).hasCard">
                    <div class="text-gray-700" v-if="parseFloat(findCustomerById(modelForm.customerId).cashbackCard.cashbackAmount) > 1">
                        <div>
                            {{ $t('customer.cashback.residue') }}:
                            {{ showCurrencyById(findCustomerById(modelForm.customerId).cashbackCard.currency.id,
                            findCustomerById(modelForm.customerId).cashbackCard.cashbackAmount - modelForm.cashback) }}
                        </div>
                    </div>
                </template>
            </div>
        </b-modal>

		<div v-if="!isShowPayType" :class="hasServices ? 'grid grid-cols-1 lg:grid-cols-3 gap-3' : 'grid grid-cols-1 lg:grid-cols-2 gap-3'">
			<!--  choose PRODUCT  -->
			<div class="position-relative pl-0 mt-3">
				<div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
					{{ $t('product.title') }}
				</div>
				<v-select
					:options="getProductsInWarehouses"
					v-model="search.productName"
					label="name"
					:closeOnSelect="false"
					:filterable="isNeedFilter"
					@input="add"
					@open="whenDropdownOpen"
					@close="whenDropdownClose"
				>
					<template #no-options="{}">
						{{ $t("selectError") }}
					</template>
					<template #search="{ attributes, events }">
						<input
							v-model="search.barCode"
							class="vs__search"
							v-bind="attributes"
							v-on="events"
							@input="(value) => {searchProductByBarCode(value)}"
							ref="search"
						/>
					</template>

				</v-select>
			</div>

			<!--  choose SERVICES  -->
			<div v-if="hasServices" class="position-relative pl-0 mt-3">
				<div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
					{{ $t('service.title') }}
				</div>
				<v-select
					:options="getServices"
					:reduce="service => service"
					:get-option-label="service => service.name"
					@input="addService"
					@open="whenDropdownOpen"
					@close="whenDropdownClose"
				>
					<template #no-options="{}">
						{{ $t("selectError") }}
					</template>
				</v-select>
			</div>

			<!--  choose CUSTOMER  -->
			<div class="position-relative pl-0 mt-3">
				<div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
					{{ $t('customer.title') }}
				</div>
				<v-select
					:options="getCustomers"
					v-model="modelForm.customerId"
					:reduce="customer => customer.id"
					:get-option-label="customer => getCustomerName(customer) + getCashbackTitle(customer)"
				>
					<template #no-options="{}">
						{{ $t("selectError") }}
					</template>

				</v-select>
			</div>
		</div>

        <!--  Hashtag & Add Customer  -->
		<div v-if="!isShowPayType" class="grid grid-cols-1 lg:grid-cols-10 mt-3">
			<div class="col-span-8 flex">
				<template v-if="modelForm.saleProductDtos.length">
					<div v-for="saleProduct of modelForm.saleProductDtos" :key="saleProduct.id">
						<div
							v-if="saleProduct.product.hashtag" class="mx-1 rounded"
							:style="`background-color: ${saleProduct.product.hashtag ? saleProduct.product.hashtag.color : ''}` ">
							<span class="text-white px-1 text-xs">#{{ saleProduct.product.hashtag.name }}</span>
						</div>
					</div>
				</template>
			</div>

			<!--  add CUSTOMER  -->
			<div  v-if="canManageCustomers()" class="col-span-2 text-right">
				<button
					class="px-1 py-1.5 border-0 bg-main text-white font-bold hover:bg-hoverMain focus:ring-0 rounded w-32 focus:outline-none"
					@click="callCustomerAddModal">
					{{ $t('customer.add') }}
				</button>
			</div>
		</div>

		<ProductListTable
            v-if="!isShowPayType"
			:class="hasMarginTop ? 'mx-n3 mt-20' : 'mx-n3 mt-3'"
			:has-margin-top="hasMarginTop"
			:is-visible="hasSale()"
			:model-form="modelForm"
			@calcTotalPrice="calculateTotalPrice"
			:is-need-refresh="refresh"
			:check-for-discount="checkForDiscount"
		/>

		<div v-if="hasSale()" class="grid grid-cols-1 md:grid-cols-4 gap-3 mt-4">
			<!--  TAX  -->
			<div v-if="!this.getUserCompany.isTaxInPrice" class="position-relative col-span-1 md:col-span-2 lg:col-span-1 pl-0 mt-3">
				<div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
					{{ $t('sale.tax.title') }}
				</div>
				<v-select
					:placeholder="$t('sale.tax.withoutTax')"
					:options="getTaxes"
					:get-option-label="option => option.name + ' ' + parseFloat(option.percent) + '%'"
					v-model="modelForm.tax"
					@input="calculateTotalPrice"
				>
					<template #no-options="{}">
						<span class="text-xs">{{ $t("selectError") }}</span>
					</template>
				</v-select>
			</div>

			<!--  CURRENCY type  -->
			<div class="position-relative pl-0 mt-3 col-span-1 md:col-span-2 lg:col-span-1">
				<div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
					{{ $t('currency') }}
				</div>
				<b-form-select
					class="h-11 border-gray-400"
					@change="exchangeCurrency"
					v-model="currentCurrencyShortName">
					<b-form-select-option value="UZS">UZS</b-form-select-option>
					<b-form-select-option value="USD">USD</b-form-select-option>
					<b-form-select-option value="RUB">RUB</b-form-select-option>
				</b-form-select>
			</div>

			<!--  DEBT paying day  -->
			<div v-if="!modelForm.isPayed" class="position-relative pl-0 mt-3 col-span-1 md:col-span-2 lg:col-span-1">
				<div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
					{{ $t('productPurchase.paymentDate') }}
				</div>
				<InputBox
					class="px-0"
					:model-form="modelForm"
					model-name="repaymentDate"
					check-to-model="modelNotLessDate"
					:errors="errors"
					:min="today"
					type="date">
				</InputBox>
			</div>

			<!--  DISCOUNT  -->
			<div v-if="modelForm.hasDiscount && modelForm.discounts.length === 0" class="position-relative pl-0 mt-3 col-span-1 md:col-span-2 lg:col-span-1">
				<div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
					{{ $t('sale.discount.title') }}
				</div>
				<b-form-input
					type="number"
					class="h-11 border-gray-400"
					v-model="bonusSumAmount"
				/>
			</div>
		</div>

        <!--  Pay Types seen only mobile -->
        <div v-if="isShowPayType" class="d-block d-md-none bg-white mt-3 pb-3 rounded">
            <div class="pt-3 font-bold text-fontColor pl-3">{{ $t('statistics.payTypes') }}
                <img src="/images/left-right.png" alt="" class="float-right mr-3 h-6">
            </div>
            <div
                class="mt-2 mx-2 gap-3 btn-group btn-group-toggle flex justify-content-around"
                data-toggle="buttons">
                <label
                    @click="payType = 'cash'"
                    class="flex justify-content-center bg-blue-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-blue-200 active focus:ring-0">
                    <input type="radio" name="pay-type" v-model="payType" checked>
                    <span
                        :class="payType === 'cash' ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                            {{ $t('statistics.categories.cash') }}
                    </span>
                    <img src="/images/cash.png" alt="" class="h-6 mt-1">
                </label>

                <label
                    @click="payType = 'bankCard'"
                    class="flex justify-content-center bg-red-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-red-200">
                    <input type="radio" name="pay-type" v-model="payType">
                    <span
                        :class="payType === 'bankCard' ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                            {{ $t('statistics.categories.bankCard') }}
                    </span>
                    <img src="/images/bankCard.png" alt="" class="h-6 mt-1">
                </label>

                <label
                    @click="payType = 'moneyTransfer'"
                    class="flex justify-content-center bg-blue-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-blue-200">
                    <input type="radio" name="pay-type" v-model="payType">
                    <span
                        :class="payType === 'moneyTransfer' ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                            {{ $t('statistics.categories.moneyTransfer') }}
                    </span>
                    <img src="/images/moneyTransfer.png" alt="" class="h-7 mt-1">
                </label>
            </div>

            <div
                    class="mt-2 mx-2 gap-3 btn-group btn-group-toggle flex justify-content-around"
                    data-toggle="buttons">
                <label
                        @click="modelForm.isPayed = true"
                        class="flex justify-content-center bg-blue-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-blue-200 active">
                    <input type="radio" name="payed-or-credit" v-model="modelForm.isPayed" checked>
                    <span
                            :class="modelForm.isPayed ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                                    {{ $t('payed') }}
                                </span>
                    <img v-if="modelForm.isPayed" src="/images/hand-shake.png" alt="" class="h-9">
                    <img v-else src="/images/payed.png" alt="" class="h-5 mt-1">
                </label>

                <label
                        @click="modelForm.isPayed = false"
                        class="flex justify-content-center bg-red-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-red-200">
                    <input type="radio" name="payed-or-credit" v-model="modelForm.isPayed">
                    <span
                        :class="!modelForm.isPayed ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                            {{ $t('onCredit') }}
                        </span>
                    <img src="/images/forDebt.png" alt="" class="h-7">
                </label>

                <label
                        class="flex justify-content-center bg-blue-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-blue-200 focus-within:bg-blue-100">
                    <input type="checkbox" name="discount" v-model="modelForm.hasDiscount" :disabled="modelForm.discounts.length > 0">
                    <span
                        :class="modelForm.hasDiscount ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                            {{ $t('sale.discount.title') }}
                        </span>
                    <img src="/images/discount.png" alt="" class="h-8">
                </label>
            </div>
        </div>

        <!--  Tax Integration seen only mobile -->
        <div v-if="isShowPayType" class="d-block d-md-none flex justify-content-between align-items-center px-2 bg-white rounded my-2">
            <div class="text-xs font-bold">{{ $t('sale.integration') }}</div>
            <div class="">
                <b-form-checkbox
                        v-b-tooltip="$t('sale.integrationTitle')"
                        inline
                        switch
                        size="lg"
                        class="mr-n2"
                        v-model="isNeedIntegration"
                        :value="true"
                        :unchecked-value="false"
                />
            </div>
        </div>

        <!--  Sale information seen only mobile -->
        <div v-if="isShowPayType" class="d-block d-md-none bg-white pb-3 rounded">
            <div class="text-fontColor font-bold ml-3 pt-2">{{ $t('sale.information') }}</div>
            <div class="flex justify-content-between px-3 mt-2">
                <div class="text-gray-500">{{ $t('product.count') }}</div>
                <div class="text-gray-500 font-bold">{{ modelForm.saleProductDtos.length }} ta</div>
            </div>
            <div class="flex justify-content-between px-3">
                <div class="text-gray-500">{{ $t('sale.totalSum') }}</div>
                <div v-if="getCurrencyByShortName(currentCurrencyShortName)" class="text-gray-500 font-bold">
                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, totalPrice) }}
                </div>
            </div>
            <div v-if="modelForm.taxAmount && !modelForm.tax.percent && getCurrencyByShortName(currentCurrencyShortName)" class="flex justify-content-between px-3">
                <div class="text-green-500">{{ $t('sale.tax.title') }}</div>
                <div v-if="getCurrencyByShortName(currentCurrencyShortName)" class="text-green-500 font-bold">
                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, modelForm.taxAmount) }}
                </div>
            </div>
            <div v-if="getCurrencyByShortName(currentCurrencyShortName)" class="flex justify-content-between px-3">
                <div class="text-green-500">{{ $t('sale.tax.inPriceOnCheck') }} {{ $t('sale.tax.title') }}</div>
                <div v-if="modelForm.tax" class="text-green-500 font-bold">
                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, modelForm.taxAmount) }}
                </div>
                <div v-else class="text-green-500 font-bold">
                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, 0) }}
                </div>
            </div>

            <div v-if="modelForm.discountPercent" class="flex justify-content-between px-3">
                <div class="text-green-500">{{ $t('sale.discount.title') }}</div>
                <div class="text-green-500 font-bold">{{ modelForm.discountPercent }}%</div>
            </div>
            <div v-if="modelForm.discountPercent > 0" class="flex justify-content-end px-3">
                <div v-if="getCurrencyByShortName(currentCurrencyShortName)" class="text-green-500 font-bold">
                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, modelForm.discountPercent * payedAmount / 100) }}
                </div>
            </div>
            <div v-if="bonusSumAmount > 0" class="flex justify-content-between px-3">
                <div class="text-green-500">{{ $t('sale.discount.title') }}</div>
                <div v-if="getCurrencyByShortName(currentCurrencyShortName)" class="text-green-500 font-bold">
                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, bonusSumAmount) }}
                </div>
            </div>


            <HrRow class="mx-1"/>

            <div class="flex justify-content-between px-3">
                <div class="text-gray-500">{{ $t('productPurchase.paymentAmount') }}</div>
                <div v-if="totalPrice && getCurrencyByShortName(currentCurrencyShortName)" class="text-gray-500 font-bold">
                    {{
                        showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount))
                    }}
                </div>
            </div>
            <div
                    v-if="Math.round(parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount) - (parseFloat(modelForm.payedAmount) + parseFloat(this.modelForm.cashback))) > 0"
                    class="flex justify-content-between px-3">
                <div class="text-red-400">{{ $t('debt') }}</div>
                <div v-if="getCurrencyByShortName(currentCurrencyShortName)" class="text-red-400 font-bold">
                    {{
                        showCurrencyById(this.getCurrencyByShortName(currentCurrencyShortName).id, (parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount)) - (parseFloat(modelForm.payedAmount) + parseFloat(this.modelForm.cashback)))
                    }}
                </div>
            </div>
            <div
                    v-else-if="Math.round(parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount)) < Math.round(parseFloat(modelForm.payedAmount))"
                    class="flex justify-content-between px-3">
                <div class="text-blue-400">{{ $t('sale.oddMoney') }}</div>
                <div v-if="getCurrencyByShortName(currentCurrencyShortName)" class="text-blue-400 font-bold">
                    {{
                        showCurrencyById(this.getCurrencyByShortName(currentCurrencyShortName).id, modelForm.payedAmount - parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount))
                    }}
                </div>
            </div>

            <div class="position-relative pl-0 mt-4 mx-3">
                <div
                        class="font-bold text-sm bg-white px-1 text-red-400 z-30 position-absolute bottom-9 ml-2">
                    {{ $t('productPurchase.paymentAmount') }}
                </div>
                <b-form-input
                        type="number"
                        class="h-11 border-red-400"
                        v-model="modelForm.payedAmount"
                />

            </div>

            <div class="mx-3 mt-3 flex gap-3">
                <button
                        @click="isShowPayType = false"
                        class="bg-orangeColor text-white font-bold border-0 rounded w-full h-11 hover:bg-red-400 focus:outline-none">
                    {{ $t('goBack') }}
                </button>
                <button
                        @click="draft"
                        class="bg-gray-300 text-gray-500 font-bold border-0 rounded w-full h-11 hover:bg-gray-400 focus:outline-none">
                    {{ $t('sale.draft') }}
                </button>
            </div>

            <div class="mx-3 mt-3" v-if="isShowCashbackButton">
                <button
                    @click="payFromCashbackModalSalePage"
                    class="bg-red-600 text-white font-bold border-0 rounded w-full h-11 hover:bg-red-500 focus:outline-none">
                    {{ $t('customer.cashback.payFromCashback') }}
                </button>
            </div>

            <div class="mx-3 mt-3">
                <button
                        @click="sale"
                        class="bg-main text-white font-bold border-0 rounded w-full h-11 hover:bg-hoverMain focus:outline-none">
                    {{ $t('sale.confirmed') }}
                </button>
            </div>

        </div>

        <div v-if="!isShowPayType" class="d-block d-md-none mt-4">
            <button
                    @click="goPayType"
                    class="bg-main text-white font-bold border-0 rounded w-full h-11 hover:bg-hoverMain focus:outline-none">
                {{ $t('sale.confirmed') }}
            </button>
        </div>

		<!-- DISCOUNT table -->
		<div class="row mt-3" v-if="modelForm.discounts.length > 0">
			<div class="col px-0">
				<hr class="mb-2">
                <div class="flex justify-content-center h-8">
                    <strong>{{ $t('sale.discount.title') }}</strong>
                </div>
				<table class="w-full">
					<thead>
					<tr class="bg-lightGray h-10">
						<th class="d-none d-md-table-cell pl-3">#</th>
						<th>{{ $t('name') }}</th>
						<th class="d-none d-md-table-cell">{{ $t('additionalInformation') }}</th>
						<th class="d-none d-md-table-cell">{{ $t('sale.discount.discountType') }}</th>
						<th>{{ $t('sale.discount.title') }}</th>
						<th>{{ $t('actions') }}</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(item, index) in sortedDiscounts"
						:key="index"
						:class="{'table-warning': !item.isActive}"
                        style="height: 40px"
					>
						<td class="d-none d-md-table-cell pl-3">{{ index + 1 }}</td>
						<td class=" text-main font-bold">{{ item.name }}</td>
						<td class="d-none d-md-table-cell text-main font-bold">{{ item.definition }}</td>
						<td class="d-none d-md-table-cell text-main font-bold">{{ getDiscountType(item) }}</td>
						<td class=" text-main font-bold">{{ getDiscount(item) }}</td>
						<td class="d-table-cell">
                            <div @click="deleteRowTable(index)">
                                <img src="/images/Union.png" alt="" class="h-6 cursor-pointer">
                            </div>
						</td>
					</tr>
					</tbody>
				</table>

				<div v-if="getDiscounts.length === 0" class="col-12">{{ $t('noData') }}</div>
			</div>
		</div>

		<RowColumn v-if="hasSale()" class="mt-4">
			<CurrencyCollapse :is-bg-white="true">
                <ProductPurchasesListTable
                    class="mx-n3"
                    :product-purchases="modelForm.saleProductDtos"
                    :is-need-refresh="isNeedRefresh"
                    :is-ready="isReady"
                />
			</CurrencyCollapse>
		</RowColumn>
	</Row>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import currencyFormat from "../../mixin/currencyFormatMixin";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import Row from "../../components/html/Row";
import Modal from "@/components/html/Modal";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import RowColumn from "@/components/RowColumn";
import CurrencyCollapse from "@/components/CurrencyCollapse";
import vSelect from "vue-select";
import '../../style/vue-select.css';
import ProductListTable from "@/components/ProductListTable";
import ModalAddCustomer from "@/components/ModalAddCustomer";
import ProductPurchasesListTable from "@/components/ProductPurchasesListTable";
import InputBox from "@/components/InputBox.vue";
import validatorMixin from "@/mixin/validatorMixin";
import accessMixin from "@/mixin/accessMixin";
import HrRow from "@/components/html/HrRow.vue";

export default {
	name: "SalesAdd",
	components: {
        HrRow,
		InputBox,
		ModalAddCustomer,
		ProductListTable,
		RowColumn,
		Modal,
		Row,
		CurrencyCollapse,
		vSelect,
		ProductPurchasesListTable,
	},
	mixins: [currencyFormat, currencyRateMixin, dateFormattingMixin, currencyFormatMixin, validatorMixin, accessMixin],
	data() {
		return {
			hasServices: false,
			bonusSumAmount: 0,
			weekdays: ["sun", "mon", "tue", "wed", "thu", "fri", "sat"],
			weekday: null,
			url: process.env.VUE_APP_API_URL,
			token: process.env.VUE_APP_EPOS_TOKEN,
			method: process.env.VUE_APP_EPOS_SALE_METHOD,
			eposUrl: process.env.VUE_APP_EPOS_API_URL,
            urlUNEC: process.env.VUE_APP_UNEC_API_URL,
			search: {
				productName: '',
				barCode: null
			},
            isShowPayType: false,
			isValidRepaymentDate: false,
			isNeedIntegration: localStorage.getItem('isNeedIntegration'),
			hasDelayed: false,
			isNeedFilter: true,
			isNeedRefresh: false,
			isReady: false,
			hasMarginTop: false,
			totalPrice: 0.0,
			refresh: false,
            isShowCashbackButton: false,
			next: null,
			today: null,
			addUnitOfMeasures: [],
			additionalUnitOfMeasures: [],
			modalText: '',
			isLoading: false,
			isLoading1: false,
			breadcrumbItems: [
				{name: 'home', url: ''},
				{name: 'sale.title'},
			],
			payType: 'cash',
			colors: ['#008F39', '#45322E', '#57A639', '#E5BE01', '#EFA94A', '#828282', '#922B3E', '#7FB5B5', '#D36E70', '#E55137', '#0E294B', '#999950', '#734222'],
			modelForm: {
				repaymentDate: null,
				taxAmount: 0,
				isTaxInPrice: false,
				totalPurchaseAmount: 0,
				bonusSumAmount: 0,
				discountPercent: 0,
				bonusPercentAmount: 0,
				discounts: [],
				isDraft: false,
				payedAmount: null,
				isPayed: true,
				saleProductDtos: [],
				saleServiceDtos: [],
				customerId: 0,
				currentCurrency: '',
				bankCard: '0',
				cash: '0',
                cashback: '0',
				moneyTransfer: '0',
				oddMoney: '0',
				description: null,
				tax: 0,
				hasDiscount: false,
			},
			integrationForm: {
				token: null,
				method: null,
				companyName: null,
				companyAddress: null,
				companyINN: null,
				staffName: null,
				phoneNumber: null,
				params: {
					items: [],
					receivedCash: 0,
					receivedCard: 0,
				},
			},
			productsWithoutICPS: [],
			modelFormCustomer: {
				isCompany: true,
				companyName: '',
				companyTelephone: '',
				givenName: '',
				familyName: '',
				gender: 1,
				telephone: '',
			},
			initialState: {
				isCompany: true,
				companyName: '',
				companyTelephone: '',
				givenName: '',
				familyName: '',
				gender: 1,
				telephone: '',
			},
			productPurchases: [],
			errors: {
				customerId: null,
				repaymentDate: null,
                cashback: null,
			},
			isCanceled: false
		}
	},
	computed: {
		...mapGetters([
			'getProductsInWarehouse',
			'getProductsInWarehouses',
			'getOfficialCurrencyRates',
			'getCompanyCurrencyRates',
			'getCustomers',
			'getInfo',
			'getSoldProductsInWarehouses',
			'getProductPurchases',
			'getNewSaleId',
			'getDiscounts',
			'getUserCompany',
			'getServices',
			'getTaxes',
			'getIkpu',
			'getIntegrationState',
			'getEpos',
			'getUser',
			'getBreadcrumbItems',
			'getPayedAmount',
			'getDiscountPercent',
			'getPayType',
			'getIsPayed',
			'getHasDiscount',
            'getIsNeedIntegration',
            'getIsMakeSale',
            'getIsMakeDraftSale',
            'getAdditionalInfo',
            'getCurrency',
            'findCustomerById',
            'getCashbackAmount',
            'getUNEC'
		]),
		isTaxExist() {
			return !this.getUserCompany.isTaxInPrice && this.modelForm.tax !== null && this.modelForm.taxAmount > 0
		},
		sortedDiscounts() {
			return this.modelForm.discounts.reduce((unique, o) => {
				if (!unique.some(obj => obj.id === o.id && obj.name === o.name)) {
					unique.push(o);
				}
				return unique;
			}, []);
		},
		hasAvailableCommunicator() {
			return this.getUserCompany.legalAddress !== null && this.getUserCompany.tin !== null
		}
	},
	methods: {
		...mapActions([
			'fetchSale',
			'putDraftSale',
			'fetchProductsIsNotify',
			'fetchAllProductsInWarehouses',
			'fetchAllCustomers',
			'fetchSoldOutProductsInWarehouses',
			'pushSale',
			'pushCustomer',
			'searchProductPurchase',
			'fetchAllDiscounts',
			'fetchAllServices',
			'fetchAllTaxes',
			'fetchProductInIkpuByBarcode',
			'pushEpos',
			'makeName',
			'setBreadcrumbItems',
			'setPayedAmount',
			'setDiscountPercent',
			'setBonusPercentAmount',
			'setTotalPrice',
			'setTaxAmount',
			'setProductAmount',
			'setPayType',
			'setIsPayed',
			'setFinalPrice',
			'setBonusSumAmount',
			'setIsDisabledManuallyDiscount',
			'setTaxPercent',
			'setTaxPercentAmount',
            'setIsMakeSale',
            'setIsMakeDraftSale',
            'setCurrentCurrencyShortName',
            'setCashbackAmount',
            'setCustomerId',
            'searchProductFromUNEC'
		]),
		...mapMutations(['addInfoToReceipt', 'clearInfoFromReceipt', 'updateNewSaleId']),
        payFromCashbackModalSalePage() {
            if (this.totalPrice > 0) {
                this.$bvModal.show('pay-from-cashback-modal')
            }
        },
        getCashbackTitle(customer) {
            if (customer.hasCard) {
                return ' (' + this.$t('customer.cashback.title') + ' ' +
                    this.showCurrencyById(customer.cashbackCard.currency.id, customer.cashbackCard.cashbackAmount) + ')'
            }

            return ''
        },
        payFromCashback() {
            if (this.isShowCashbackButton) {
                this.modelForm.payedAmount -= this.modelForm.cashback
                this.modelForm.payedAmount = this.modelForm.payedAmount.toString()
            } else {
                this.setCashbackAmount(this.modelForm.cashback)
            }
        },
        getCustomerName(customer) {
            if (customer) {
                return customer.isCompany ?
                    customer.customerCompany.name :
                    customer.person.givenName + ' ' + customer.person.familyName
            }
        },
        goPayType() {
            this.isShowPayType = true
        },
		hashtagMaker(product) {
			if (product.categories.length) {
				let hashtag = {}
				hashtag.name = product.categories[0].name
				hashtag.color = this.colors[Math.floor(Math.random() * this.colors.length)]
				product.hashtag = hashtag
			}
		},
		goNext() {
			this.next()
		},
		calcTaxAmount(amount, percent) {
			return amount * percent / 100
		},
		isTaxAvailableInProduct(saleProduct) {
			return !this.getUserCompany.isTaxInPrice &&
				saleProduct.product.tax !== null &&
				saleProduct.product.tax === this.getUserCompany.tax
		},
		numberWithCommas(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
		},
		getDiscountType(discount) {
			switch (discount.discountType) {
				case 'sum':
					return this.$t('sale.discount.discountSum')

				case 'product':
					return this.$t('sale.discount.discountProduct')

				case 'percent':
					return this.$t('sale.discount.discountPercent')
			}
		},
		calculateReversePercentAmount(amount, percent) {
			if (percent === null) {
				percent = 0
			}

			return amount * 100 / (100 - percent)
		},
		calculatePercentAmount(amount, percent) {
			if (percent === null) {
				percent = 0
			}

			return this.currentCurrencyShortName === 'UZS' ? parseInt(amount * (100 - percent) / 100) : (amount * (100 - percent) / 100).toFixed(2)
		},
		getTotalPriceWithoutDiscountIfTaxExist() {
			return this.showCurrencyById(
				this.getCurrencyByShortName(this.currentCurrencyShortName).id,
				this.calculateReversePercentAmount(
					(parseFloat(this.totalPrice) + parseFloat(this.modelForm.bonusSumAmount)),
					this.modelForm.discountPercent)
			)
		},
		getPercentAmount() {
			let amount = this.calculateReversePercentAmount(
				(parseFloat(this.totalPrice) + parseFloat(this.modelForm.bonusSumAmount)),
				this.modelForm.discountPercent
			)

			this.modelForm.bonusPercentAmount = this.calculatePercentAmount(
				amount,
				(100 - this.modelForm.discountPercent)
			)

			return this.showCurrencyById(
				this.getCurrencyByShortName(this.currentCurrencyShortName).id,
				this.modelForm.bonusPercentAmount
			)
		},
		addBonusProduct(discountProduct) {
			return this.getProductsInWarehouses.find(piw => {
				if (piw.product.id === discountProduct.product.id && piw.amount >= discountProduct.amountForDiscount) {
					let data = JSON.parse(JSON.stringify(piw))
					data.quantity = discountProduct.amountForDiscount
					data.product.sellingPrice = 0
					data.isBonus = true
					this.addProductToDtos(data)
				}
			})
		},
		isProductExist(discountProduct) {
			return this.modelForm.saleProductDtos.find(spd => {
				if (spd.product.id === discountProduct.product.id && spd.isBonus && spd.amount >= spd.quantity + 1) {
					this.addProductToDtos(spd)
					return spd
				}
			}) === undefined
		},
		checkDiscountType(discount, times, isRemoved) {
			if (isRemoved) {
				times = 1
			}

			for (let i = 1; i <= times; i++) {
				let isProductAdded = false

				switch (discount.discountType) {
					case 'sum':
						this.bonusSumAmount += discount.discountSum
						break;

					case 'product':
						discount.discountProducts.map(dp => {
							if (dp.isBonus) {
								if (!(isProductAdded = !this.isProductExist(dp))) {
									isProductAdded = !!this.addBonusProduct(dp)
								}
							}
						})

						break;
				}

				if (!isRemoved) {
					if (discount.discountType === 'product' && isProductAdded) {
						this.modelForm.discounts.push(discount)
					} else {
						this.modelForm.discounts.push(discount)
					}
				}

				this.calculateTotalPrice()
			}
		},
		isDiscountAvailableForCustomer(discount) {
			return (discount.isForAllUsers ||
					discount.privilegedUsers.find(c => c.id === this.modelForm.customerId)) &&
				discount.activeDays.split(' ').find(day => day === this.weekday) !== undefined
		},
		checkForDiscount(isRemoved = false) {
			if (!isRemoved) {
				this.modelForm.discounts = []
			}

			this.modelForm.discountPercent = 0
			this.modelForm.bonusSumAmount = 0
			this.bonusSumAmount = 0
			this.modelForm.saleProductDtos = this.modelForm.saleProductDtos.filter(spd => !spd.isBonus)

			this.modelForm.saleProductDtos.map(spd => {
				if (spd.discountPercent) {
					delete spd.discountPercent
				}
			})

			let data = isRemoved ? this.modelForm.discounts : this.getDiscounts

			data.map(d => {
				if (this.isDiscountAvailableForCustomer(d)) {
					let times =
						Math.floor(
							this.calculateTotalPrice() /
							this.calculateAmountByBaseCurrency(d.forTotalSum,
								this.baseCurrencyShortName,
								this.currentCurrencyShortName
							)
						)

					if (d.isForAllProducts && times > 0) {
						if (d.discountType === 'percent') {
							this.modelForm.discountPercent += d.discountPercent
							times = 1
						}

						this.checkDiscountType(d, times, isRemoved)
					} else {
						this.modelForm.saleProductDtos.map(piw => {
							if (d.discountProducts.find(dd => {
								times = Math.floor((piw.quantity + piw.addQuantity) / dd.amountForDiscount)

								if (dd.product.id === piw.product.id && times > 0 && !dd.isBonus && !piw.isBonus) {
									if (d.discountType === 'percent') {
										times = 1
										piw.discountPercent = d.discountPercent
									}

									return dd
								}
							}) !== undefined) {
								this.checkDiscountType(d, times, isRemoved)
							}
						})
					}
				}
			})

			this.calculateTotalPrice()
		},
		getDiscount(discount) {
			let name = ''

			switch (discount.discountType) {
				case 'product':
					discount.discountProducts.map(d => {
						if (d.isBonus) {
							name += ' ' + d.product.name + " " + d.amountForDiscount + ' ||'
						}
					})

					return name;

				case 'sum':
					return this.showCurrencyById(this.baseCurrencyId, discount.discountSum);

				case 'percent':
					return discount.isForAllProducts ?
						(this.$t('sale.discount.forTotalSum') + ' ' + discount.discountPercent + ' %') :
						(this.$t('sale.discount.forProduct') + ' ' + discount.discountPercent + ' %');
			}
		},
		deleteRowTable(index) {
			this.modelForm.discounts.splice(index, 1)
			this.checkForDiscount(true)
		},
		addService(service) {
			service.service = service['@id']

			if (!this.modelForm.saleServiceDtos.includes(service)) {
				service.amount = 1

				if (service.currency.shortName === "UZS") {
					service.price = parseInt(service.price)
				} else {
					service.price = parseFloat(service.price)
				}

				this.modelForm.saleServiceDtos.unshift(service)

				// setTimeout(() => this.scrollTable(this.modelForm.saleServiceDtos.length - 1), 200)
			} else {
				let index = this.modelForm.saleServiceDtos.findIndex(item => item === service)

				this.serviceIncreaseAmount(this.modelForm.saleServiceDtos[index])
				this.calculateTotalPrice()
				// setTimeout(() => this.scrollTable(index), 200)
			}
		},
		// piw - productInWarehouse
		add(piw) {
			if (!this.hasDelayed) {
				this.addProductToDtos(piw)
			}

			this.checkForDiscount()
			this.search.productName = ''
		},
		whenDropdownOpen() {
			this.hasMarginTop = true
		},
		whenDropdownClose() {
			this.hasMarginTop = false
		},
		isNumber(n) {
			return /^-?[\d.]+(?:e-?\d+)?$/.test(n)
		},
		onBarcodeScanned(barcode) {
			if (this.isNumber(barcode)) {
				this.search.barCode = barcode
				this.searchProductByBarCode()
			}
		},
		searchProductByBarCode() {
			if (this.search.barCode.length === 13) {
				this.isNeedFilter = false
				this.hasDelayed = true

				let piw = this.getProductsInWarehouses.find(piw => this.search.barCode === piw.product.barCode)

				if (piw === undefined) {
					this.isNeedFilter = true

					setTimeout(() => {
						this.search.barCode = ""
					}, 1500)
				} else {
					this.addProductToDtos(piw)

					setTimeout(() => {
						this.search.barCode = ""
					}, 200)
					setTimeout(() => {
						this.hasDelayed = false
						this.isNeedFilter = true
					}, 500)
				}
			}
		},
		exchangeCurrency() {
			this.calculateTotalPrice()
		},
		calculateTotalPrice() {
			this.isNeedRefresh = !this.isNeedRefresh

			switch (this.currentCurrencyShortName) {
				case 'USD': {
					return this.totalPrice = this.showCurrencyById(null, this.converterToValute('USD'))
				}

				case 'RUB': {
					return this.totalPrice = this.showCurrencyById(null, this.converterToValute('RUB'))
				}

				case 'UZS': {
					return this.totalPrice = this.showCurrencyById(null, this.converterToValute('UZS'))
				}
			}
		},
		addProductToDtos(piw) {
			piw.productInWarehouse = piw['@id']

			if (piw.amount < 1) {
				this.notEnoughProductId = piw.id
			}

			if (piw.addQuantity === undefined) {
				piw.addQuantity = 0
			}

			if (piw.product.additionalUnitOfMeasures.length > 0) {
				piw.product.additionalUnitOfMeasures.forEach((unit) => {
					unit.quantity = 0
				})
			}

			if (!this.modelForm.saleProductDtos.includes(piw)) {
				piw.quantity = 1

				switch (piw.product.sellingPriceCurrency.shortName) {
					case "UZS":
						piw.product.sellingPrice = parseInt(piw.product.sellingPrice)
						break

					default:
						piw.product.sellingPrice = parseFloat(piw.product.sellingPrice)
						break
				}

				if (piw.product.barCode !== null) {
					if (piw.product.id === parseInt(piw.product.barCode.slice(2, 7)) && parseInt(piw.product.barCode.slice(0, 1)) === 2) {
						if (parseInt(piw.product.barCode.slice(1, 2)) === 1) {
							piw.quantity = parseInt(piw.product.barCode.slice(7, 12)) / 1000
							piw.quantity = parseFloat(piw.quantity)
						}
					}
				}

				this
                    .searchProductFromUNEC({barcode: piw.product.barCode, url: this.urlUNEC})
					.then(() => {
                        if (this.getUNEC) {
                            piw.classCode = this.getUNEC.mxikCode
                            piw.isValid = true
                        } else {
                            this.productsWithoutICPS.push(piw.product.name)
                            piw.isValid = false
                        }
					})

				this.findProductPurchase(piw, function (model, piw) {
					model.saleProductDtos.unshift(piw)
				})

                this.hashtagMaker(piw.product)
			} else {
				let index = this.modelForm.saleProductDtos.findIndex(item => item === piw)

				this.increaseAmount(this.modelForm.saleProductDtos[index])
				this.calculateTotalPrice()
			}

			this.search.barCode = ''
		},
		findProductPurchase(piw, callback) {
            piw.currency = this.getCurrency(3)

            this
				.searchProductPurchase({productId: piw.product.id, isPayed: null})
				.then(() => {
					piw.createdAt = this.getProductPurchases[0].createdAt
					piw.pricePerUnit = this.getProductPurchases[0].pricePerUnit
					piw.supplier = this.getProductPurchases[0].supplier
					piw.currency = this.getProductPurchases[0].currency
					this.isReady = !this.isReady
				})

            callback(this.modelForm, piw)
		},
		serviceIncreaseAmount(service) {
			service.amount++
		},
		increaseAmount(piw, unit = null, index = null) {
			if (unit === null) {
				if (piw.quantity < piw.amount) {
					piw.quantity++
				} else if (piw.quantity >= piw.amount) {
					this.notEnoughProductId = piw.id
				}
			} else {
				if (piw.product.additionalUnitOfMeasures[index].howMany + parseInt(piw.quantity) + piw.addQuantity > piw.amount) {
					this.notEnoughProductId = piw.id
				} else {
					piw.addQuantity += piw.product.additionalUnitOfMeasures[index].howMany
					piw.product.additionalUnitOfMeasures[index].quantity++
				}
			}

			this.refresh = !this.refresh
		},
		definePayType() {
			switch (this.selectForm) {
				case "bankCard":
					this.modelForm.bankCard = this.modelForm.payedAmount
					this.modelForm.moneyTransfer = '0'
					break

				case "moneyTransfer":
					this.modelForm.moneyTransfer = this.modelForm.payedAmount
					this.modelForm.bankCard = '0'
					break
			}
		},
		calcBankCardAmount() {
			if (this.modelForm.isPayed) {
				this.modelForm.bankCard = this.totalPrice
			} else {
				this.modelForm.bankCard = this.modelForm.payedAmount
			}

			this.modelForm.bankCard = this.modelForm.bankCard.toString()
		},
		calcMoneyTransferAmount() {
			if (this.modelForm.isPayed) {
				this.modelForm.moneyTransfer = this.totalPrice
			} else {
				this.modelForm.moneyTransfer = this.modelForm.payedAmount
			}

			this.modelForm.moneyTransfer = this.modelForm.moneyTransfer.toString()
		},
		calcCashAmount() {
			if (this.modelForm.isPayed) {
				this.modelForm.cash = this.modelForm.tax ? (parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount)).toString() : this.totalPrice
			} else {
				this.modelForm.cash = this.modelForm.payedAmount
			}
		},
		calcPayType() {
			if (this.payType === 'cash') {
				this.calcCashAmount()
			}

			if (this.payType === 'bankCard') {
				this.calcBankCardAmount()
			}

			if (this.payType === 'moneyTransfer') {
				this.calcMoneyTransferAmount()
			}

			this.modelForm.currentCurrency = this.currentCurrencyShortName
		},
		calcOddMoney() {
			this.modelForm.oddMoney = this.modelForm.payedAmount - (parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount))
			this.modelForm.oddMoney = this.modelForm.oddMoney.toString()
			this.modelForm.payedAmount = parseFloat((parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount)).toFixed(2)).toString()
		},
		pushSale() {
			let wasDraft = this.modelForm.isDraft
			this.modelForm.isDraft = false

			//if this is draft or edit sale page
			if (this.$route.name === "sales/edit" && wasDraft) {
				// here will be canceled current draft sale
				this.$store.dispatch('pushSaleCancel', {id: this.$route.params.id})
					.then(() => {
						this.connectToEpos()
						// here will be pushed sale
						this.$store.dispatch('pushSale', this.modelForm)
							.then(response => {
								this.fetchProductsIsNotify()
								this.newUrl(response.id)
								this.isLoading = false
								this.$root.showOverlay = false
							})
							.catch((reason) => {
								this.isLoading = false
								this.$root.showOverlay = false
								this.modalText = reason
								this.$bvModal.show('modal_show')
							})
					})
					.catch((reason) => {
						this.$root.showOverlay = false
						this.isLoading = false
						this.modalText = reason
						this.$bvModal.show('modal_show')
					})
			} else {
				if (this.hasNeedIntegration() && this.isNeedIntegration) {
					this.connectToEpos()
				}
				// here will be pushed sale
				this.$store.dispatch('pushSale', this.modelForm)
					.then(response => {
						console.log(response)
						this.fetchProductsIsNotify()

						if (this.hasNeedIntegration() && this.isNeedIntegration) {
							this.$root.showOverlay = false

							return
						}

                        this.modelForm.cashback = '0'
                        this.$store.state.customer.customers.isNeedFetch = true
                        this
                            .fetchAllCustomers()
                            .then(() => {
                                this.afterFetchCustomer(this.getCustomers)
                            })

						this.newUrl(response.id)
						this.isLoading = false
						this.$root.showOverlay = false
					})
					.catch((reason) => {
						this.isLoading = false
						this.$root.showOverlay = false
						this.modalText = reason
						this.$bvModal.show('modal_show')
					})
			}
		},
		newUrl(id) {
			this.updateNewSaleId(id)
			this.fetchSale(id)
				.then(() => {
					this.$i18nHelper.toUrl('sales/transactions/' + id + '/check-print')
				})
		},
		proceedSale() {
			this.$root.showOverlay = true

			if (new Date(this.modelForm.repaymentDate) < new Date(this.today) || this.modelForm.repaymentDate === "") {
				this.isValidRepaymentDate = true
				return
			}

			if (parseFloat(this.modelForm.payedAmount) === parseFloat(this.totalPrice) + this.modelForm.taxAmount) {
				this.modelForm.isPayed = true
			}

			if (this.modelForm.isPayed) {
				if (parseFloat(this.modelForm.payedAmount) >= parseFloat(this.totalPrice)) {
					this.calcOddMoney()
				}
			} else {
				if (this.modelForm.payedAmount === null || this.modelForm.payedAmount === '') {
					this.modelForm.payedAmount = 0
				} else {
					this.definePayType()
				}

				this.modelForm.payedAmount = this.modelForm.payedAmount.toString()
			}

			this.isLoading = true

			this.modelForm.bonusSumAmount = this.modelForm.bonusSumAmount.toString()
			this.modelForm.bonusPercentAmount = this.modelForm.bonusPercentAmount.toString()

			this.modelForm.totalPurchaseAmount = (parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount)).toString()

			this.modelForm.taxAmount = this.modelForm.taxAmount.toString()

			this.calcPayType()
			this.addInfoToReceipt(this.modelForm.description)
			this.pushSale()
		},
		sale() {
            this.getPercentAmount()

			if (!this.hasAllWillSendToEpos() && JSON.parse(this.isNeedIntegration) && this.hasNeedIntegration() && this.hasAvailableCommunicator) {
				this.$bvModal.show('epos_cannot_send_all')
				return
			}

			if (!this.hasNeedIntegration() && JSON.parse(this.isNeedIntegration) && this.hasAvailableCommunicator) {
				this.modalText = this.$t('sale.integrationWarningCantSend')
				this.$bvModal.show('epos_warning')
				return
			}

			if (new Date(this.modelForm.repaymentDate) < new Date(this.today) || this.modelForm.repaymentDate === "") {
				this.isValidRepaymentDate = true
				return
			}

			this.$root.showOverlay = true

			if (parseFloat(this.modelForm.payedAmount) === parseFloat(this.totalPrice) + this.modelForm.taxAmount) {
				this.modelForm.isPayed = true
			}

			if (this.modelForm.isPayed) {
				if (parseFloat(this.modelForm.payedAmount) >= parseFloat(this.totalPrice)) {
					this.calcOddMoney()
				}
			} else {
				if (this.modelForm.payedAmount === null || this.modelForm.payedAmount === '') {
					this.modelForm.payedAmount = 0
				} else {
					this.definePayType()
				}

				this.modelForm.payedAmount = this.modelForm.payedAmount.toString()
			}

			this.isLoading = true

			this.modelForm.bonusSumAmount = this.modelForm.bonusSumAmount.toString()
			this.modelForm.bonusPercentAmount = this.modelForm.bonusPercentAmount.toString()

			this.modelForm.totalPurchaseAmount = (parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount)).toString()

			this.modelForm.taxAmount = this.modelForm.taxAmount.toString()

			this.calcPayType()
			this.addInfoToReceipt(this.modelForm.description)
			this.pushSale()
		},
		draft() {
			this.$root.showOverlay = true

			this.modelForm.isDraft = true

			if (this.modelForm.isPayed) {
				if (parseFloat(this.modelForm.payedAmount) >= parseFloat(this.totalPrice)) {
					this.calcOddMoney()
				}
			} else {
				if (this.modelForm.payedAmount === null || this.modelForm.payedAmount === '') {
					this.modelForm.payedAmount = 0
				} else {
					this.definePayType()
				}

				this.modelForm.payedAmount = this.modelForm.payedAmount.toString()
			}

			this.isLoading1 = true

			this.modelForm.bonusSumAmount = this.modelForm.bonusSumAmount.toString()
			this.modelForm.bonusPercentAmount = this.modelForm.bonusPercentAmount.toString()

			this.modelForm.totalPurchaseAmount = this.calculateReversePercentAmount(
				(parseFloat(this.totalPrice) + parseFloat(this.modelForm.bonusSumAmount) + this.modelForm.taxAmount),
				this.modelForm.discountPercent
			).toString()

			this.modelForm.taxAmount = this.modelForm.taxAmount.toString()
			this.calcPayType()

			//if this is edit page
			if (this.$route.name === "sales/edit" && !this.isCanceled) {
				this.modelForm.saleProductDtos.forEach((product) => {
					product.amount = (product.quantity + product.addQuantity)
					product.amount = parseFloat(product.amount)

					if (!product.productInWarehouse) {
						product.productInWarehouse = product['@id']
					}

					product.price = product.sum.toString()
				})
				this.modelForm.company = this.modelForm.company['@id']
				this.modelForm.payedAmount = Math.round(this.modelForm.payedAmount)
				this.modelForm.payedAmount = this.modelForm.payedAmount.toString()
				this.modelForm.id = this.$route.params.id

				//here will be updated draft sale
				this.$store.dispatch('pushDraftSale', this.modelForm)
					.then(() => {
						this.isLoading1 = false
						this.$root.showOverlay = false
						this.selectForm = ''
						this.$i18nHelper.toUrl('sales/drafts')
					})
					.catch((reason) => {
						this.isLoading1 = false
						this.$root.showOverlay = false
						this.modalText = reason
						this.$bvModal.show('modal_show')
					})
			} else {
				//here will be pushed draft sale
				this.$store.dispatch('pushSale', this.modelForm)
					.then(() => {
						this.isLoading1 = false
						this.$root.showOverlay = false
						this.selectForm = ''
						this.$i18nHelper.toUrl('sales/drafts')
					})
					.catch((reason) => {
						this.isLoading1 = false
						this.$root.showOverlay = false
						this.modalText = reason
						this.$bvModal.show('modal_show')
					})
			}
		},
		hasSale() {
			return this.modelForm.saleProductDtos.length > 0 || this.modelForm.saleServiceDtos.length > 0
		},
		serviceConverterToValute(shortName) {
			let inUSD = 0.0
			let inUZS = 0.0
			let inRUB = 0.0

			for (let service of this.modelForm.saleServiceDtos) {
				if (service.currency.id === this.getCurrencyByShortName('USD').id) {
					service.totalSum = this.calculateAmountByBaseCurrency(
						service.amount * parseFloat(service.price),
						'USD',
						this.currentCurrencyShortName
					)

					inUSD += (parseFloat(service.amount) * parseFloat(service.price))
				}

				if (service.currency.id === this.getCurrencyByShortName('RUB').id) {
					service.totalSum = this.calculateAmountByBaseCurrency(
						service.amount * parseFloat(service.price),
						'RUB',
						this.currentCurrencyShortName
					)

					inRUB += (parseFloat(service.amount) * parseFloat(service.price))
				}

				if (service.currency.id === this.getCurrencyByShortName('UZS').id) {
					service.totalSum = this.calculateAmountByBaseCurrency(
						service.amount * parseFloat(service.price),
						'UZS',
						this.currentCurrencyShortName
					)

					inUZS += (parseFloat(service.amount) * parseFloat(service.price))
				}
			}

			return this.calculateAmountByBaseCurrency(inUZS, "UZS", shortName) +
				this.calculateAmountByBaseCurrency(inUSD, "USD", shortName) +
				this.calculateAmountByBaseCurrency(inRUB, "RUB", shortName)
		},
		calculateTotalAmountBaseCurrency(piw, shortName) {
			piw.sum = this.calculateAmountByBaseCurrency(
				((piw.quantity + piw.addQuantity) * parseFloat(piw.product.sellingPrice)),
				shortName,
				this.currentCurrencyShortName
			)

			let sum = ((parseFloat(piw.quantity) + parseFloat(piw.addQuantity)) * parseFloat(piw.product.sellingPrice))
			let taxSum = 0.0

			if (this.isTaxAvailableInProduct(piw)) {
				taxSum = this.calcTaxAmount(sum, parseFloat(piw.product.tax.percent))
			} else if (!this.getUserCompany.isTaxInPrice && this.modelForm.tax !== null) {
				if (this.modelForm.discountPercent > 0) {
					let discountPercentAmount = this.modelForm.discountPercent * sum / 100
					taxSum = this.calcTaxAmount((sum - discountPercentAmount), parseFloat(this.modelForm.tax.percent))
				} else if (this.modelForm.bonusSumAmount > 0) {
					taxSum = this.calcTaxAmount((sum -
						this.calculateAmountByBaseCurrency(this.modelForm.bonusSumAmount, this.currentCurrencyShortName, shortName)
					), parseFloat(this.modelForm.tax.percent))
					if (taxSum < 0.0) {
						taxSum = 0.0
						taxSum = this.calcTaxAmount(sum, parseFloat(this.modelForm.tax.percent))
					}
				} else {
					if (piw.discountPercent !== undefined) {
						let discountAmount = piw.discountPercent * sum / 100
						taxSum = this.calcTaxAmount(sum - discountAmount, parseFloat(this.modelForm.tax.percent))
					} else {
						taxSum = this.calcTaxAmount(sum, parseFloat(this.modelForm.tax.percent))
					}
				}
			}

			if (piw.discountPercent && !piw.isBonus) {
				piw.sum = this.calculatePercentAmount(piw.sum, piw.discountPercent)
				sum = this.calculatePercentAmount(sum, piw.discountPercent)
			}

			return [sum, taxSum]
		},
		converterToValute(shortName) {
			let inUSD = 0.0
			let taxInUSD = 0.0
			let inRUB = 0.0
			let taxInRUB = 0.0
			let inUZS = 0.0
			let taxInUZS = 0.0

			for (let piw of this.modelForm.saleProductDtos) {

				if (piw.product.sellingPriceCurrency.id === this.getCurrencyByShortName('USD').id) {
					let data = this.calculateTotalAmountBaseCurrency(piw, 'USD')
					inUSD += data[0]
					taxInUSD += data[1]
				}

				if (piw.product.sellingPriceCurrency.id === this.getCurrencyByShortName('RUB').id) {
					let data = this.calculateTotalAmountBaseCurrency(piw, 'RUB')
					inRUB += data[0]
					taxInRUB += data[1]
				}

				if (piw.product.sellingPriceCurrency.id === this.getCurrencyByShortName('UZS').id) {
					let data = this.calculateTotalAmountBaseCurrency(piw, 'UZS')
					inUZS += data[0]
					taxInUZS += data[1]
				}
			}

			let amount =
				this.calculateAmountByBaseCurrency(inUZS, "UZS", shortName) +
				this.calculateAmountByBaseCurrency(inUSD, "USD", shortName) +
				this.calculateAmountByBaseCurrency(inRUB, "RUB", shortName)

			this.modelForm.taxAmount =
				this.calculateAmountByBaseCurrency(taxInUZS, "UZS", shortName) +
				this.calculateAmountByBaseCurrency(taxInUSD, "USD", shortName) +
				this.calculateAmountByBaseCurrency(taxInRUB, "RUB", shortName)

			if (this.modelForm.discountPercent > 0) {
				amount = this.calculatePercentAmount(amount, this.modelForm.discountPercent)
			}

			if (this.bonusSumAmount > 0) {
				this.modelForm.bonusSumAmount = this.calculateAmountByBaseCurrency(
					this.bonusSumAmount,
					this.baseCurrencyShortName,
					shortName
				)

				amount = amount - this.modelForm.bonusSumAmount
				if (this.modelForm.tax !== null) {
					this.modelForm.taxAmount = this.modelForm.tax.percent * amount / 100
				}
			}

			return amount + this.serviceConverterToValute(shortName)
		},
		// customer & unites
		callCustomerAddModal() {
			this.$bvModal.show('customer_add')
		},
		afterFetchCustomer(models) {
			if (models.length > 0) {
				this.modelForm.customerId = models[0].id
			}

			for (let index in models) {
				let customer = models[index];

				models[index].text = customer.isCompany ?
					customer.customerCompany.name :
					customer.person.givenName + ' ' + customer.person.familyName
			}
		},
		chooseNewCustomer() {
            this.$store.state.customer.customers.isNeedFetch = true

			this
				.fetchAllCustomers()
				.then(() => {
					this.afterFetchCustomer(this.getCustomers)
					this.modelForm.customerId = this.getCustomers[this.getCustomers.length - 1].id
					this.$bvModal.hide('customer_add')
					this.modelFormCustomer = this.initialState
				})
		},
		scrollTable(index) {
			let rows = [];

			if (this.modelForm.saleProductDtos.length + this.modelForm.saleServiceDtos.length > 3) {
				let table = document.querySelector('table');
				// get array of rows of table products
				rows = table.querySelectorAll('tr');
			}

			if (rows.length > 3) {
				// scroll index of table row
				rows[index].scrollIntoView({
					behavior: 'smooth',
					block: 'center'
				})
			}
		},
		getTodayDate() {
			let yearNow = new Date().getFullYear()
			let monthNow = new Date().getMonth() + 1
			let dateNow = new Date().getDate()

			return yearNow + '-' + this.addZero(monthNow) + '-' + this.addZero(dateNow)
		},
		addZero(val) {
			return val < 10 ? '0' + val : val;
		},
		resetData() {
			this.printEpos()

			setTimeout(() => {
				Object.assign(this.$data, this.$options.data.call(this));

				this.afterFetchCustomer(this.getCustomers)

				this.modelForm.tax = this.getUserCompany.tax
				this.modelForm.isTaxInPrice = this.getUserCompany.isTaxInPrice
			}, 3000)
		},
		printEpos() {
			this.$bvModal.show('epos_print_sale')

			setTimeout(() => {
				let obj = document.createElement('object')
				obj.style.width = '100%'
				obj.style.height = '582pt'
				obj.type = 'application/pdf'
				obj.data = 'data:application/pdf;base64,' + this.getEpos.paycheck
				let myDiv = document.getElementById('epos_receipt')
				myDiv.appendChild(obj)

			}, 200)
		},
		hasAllWillSendToEpos() {
			return this.modelForm.saleProductDtos.every((saleProduct) => {
				return saleProduct.isValid
			})
		},
		hasNeedIntegration() {
			return this.modelForm.saleProductDtos.some((saleProduct) => {
				return saleProduct.isValid
			})
		},
		makeDataToEpos() {
			this.integrationForm.token = this.token
			this.integrationForm.method = this.method
			this.integrationForm.companyName = this.getUserCompany.name
			this.integrationForm.companyAddress = this.getUserCompany.legalAddress
			this.integrationForm.companyINN = this.getUserCompany.tin
			this.integrationForm.staffName = this.getUser.person.givenName + ' ' + this.getUser.person.familyName
			this.integrationForm.phoneNumber = this.getUser.person.telephone
			this.integrationForm.params.receivedCash = +this.modelForm.cash * 100
			this.integrationForm.params.receivedCard = +this.modelForm.bankCard * 100

			this.makeDataItem()
		},
		makeDataItem() {
			for (let saleProduct of this.modelForm.saleProductDtos) {
				if (saleProduct.isValid) {
					let item = {
						discount: this.calcDiscountAmount() * 100,
						price: this.calculateAmountToUZS(saleProduct.sum) * 100,
						barcode: saleProduct.product.barCode,
						amount: saleProduct.quantity * 1000,
						vatPercent: parseInt(this.getUserCompany.tax.percent),
						vat: (saleProduct.sum - this.calcDiscountAmount()) * this.getUserCompany.tax.percent,
						name: saleProduct.product.name,
						classCode: saleProduct.classCode,
						units: null,
						commissionTIN: null,
						other: 0,
					}

					this.integrationForm.params.items.push(item)
				}
			}
		},
		calcDiscountAmount() {
			if (this.modelForm.discounts.length > 0 || +this.modelForm.bonusSumAmount > 0) {
				return (+this.modelForm.bonusSumAmount + +this.modelForm.bonusPercentAmount) / this.modelForm.saleProductDtos.length
			}

			return 0
		},
		async connectToEpos() {
			await this.makeDataToEpos()

			this.integrationForm.url = this.eposUrl

			await this
				.pushEpos(this.integrationForm)
				.then(() => {
					this.resetData()
					this.$root.showOverlay = false
					this.isLoading = false
				})
				.catch((reason) => {
					this.isLoading = false
					this.$root.showOverlay = false
					this.modalText = reason
					this.$bvModal.show('modal_show')
				})
		}
	},
	watch: {
		'modelForm.saleProductDtos.length'() {
			this.calculateTotalPrice()
			this.setProductAmount(this.modelForm.saleProductDtos.length)
		},
		'modelForm.saleServiceDtos.length'() {
			this.calculateTotalPrice()
		},
		'totalPrice'() {
			this.modelForm.payedAmount = parseFloat((parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount)).toFixed(2)).toString()

			this.setTotalPrice(this.calculateReversePercentAmount((parseFloat(this.totalPrice) + parseFloat(this.modelForm.bonusSumAmount)), this.modelForm.discountPercent))
			this.setFinalPrice(parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount))

            if (this.modelForm.tax) {
                this.setTaxPercentAmount(this.calcTaxAmount(this.totalPrice, this.modelForm.tax.percent))
                this.setTaxPercent(this.modelForm.tax.percent)
            }
		},
		'modelForm.isPayed'() {
			if (this.modelForm.isPayed && parseFloat(this.modelForm.payedAmount) < parseFloat(this.totalPrice)) {
				this.modelForm.payedAmount = parseFloat((parseFloat(this.totalPrice) + this.modelForm.taxAmount).toFixed(2)).toString()
			}

			if (!this.modelForm.isPayed) {
				this.modelForm.payedAmount = 0
			}
		},
		'modelForm.payedAmount'() {
			if (Math.round(parseFloat(this.modelForm.payedAmount)) < Math.round(parseFloat(this.totalPrice) + this.modelForm.taxAmount) || this.modelForm.payedAmount === '') {
                if (!this.isShowCashbackButton) {
                    this.modelForm.isPayed = false
                }
			} else if (Math.round(parseFloat(this.modelForm.payedAmount)) >= Math.round(parseFloat(this.totalPrice) + this.modelForm.taxAmount)) {
				this.modelForm.isPayed = true
			}

			this.setPayedAmount(this.modelForm.payedAmount)
			this.setDiscountPercent(this.modelForm.discountPercent)
		},
		'modelForm.discountPercent'() {
			this.setDiscountPercent(this.modelForm.discountPercent)
		},
		'modelForm.bonusSumAmount'() {
			this.setBonusSumAmount(this.bonusSumAmount)
		},
		'payType'() {
			this.setPayType(this.payType)
		},
        'currentCurrencyShortName'() {
            this.setCurrentCurrencyShortName(this.currentCurrencyShortName)
        },
        getCashbackAmount: {
            deep: true,
            handler: function (newVal) {
                this.modelForm.cashback = newVal
            }
        },
		getPayedAmount: {
			deep: true,
			handler: function (newVal) {
				this.modelForm.payedAmount = newVal
			}
		},
		getPayType: {
			deep: true,
			handler: function (newVal) {
				this.payType = newVal
			}
		},
		getIsPayed: {
			deep: true,
			handler: function (newVal) {
				this.modelForm.isPayed = newVal
			}
		},
		getHasDiscount: {
			deep: true,
			handler: function (newVal) {
				this.modelForm.hasDiscount = newVal
			}
		},
        getIsNeedIntegration: {
			deep: true,
			handler: function (newVal) {
				this.isNeedIntegration = newVal
			}
		},
        getIsMakeSale: {
			deep: true,
			handler: function (newVal) {
                if (newVal) {
                    this.sale()
                }

                this.setIsMakeSale(false)
			}
		},
        getIsMakeDraftSale: {
            deep: true,
            handler: function (newVal) {
                if (newVal) {
                    this.draft()
                }

                this.setIsMakeDraftSale(false)
            }
        },
        getAdditionalInfo: {
			deep: true,
			handler: function (newVal) {
               this.modelForm.description = newVal
			}
		},
		'modelForm.customerId'() {
			this.checkForDiscount()
            this.setCustomerId(this.modelForm.customerId)
            this.isShowCashbackButton = !!this.findCustomerById(this.modelForm.customerId).hasCard;
		},
		'modelForm.tax'() {
			this.modelForm.payedAmount = parseFloat((parseFloat(this.totalPrice) + this.modelForm.taxAmount).toFixed(2)).toString()
            this.setFinalPrice(parseFloat(this.totalPrice) + parseFloat(this.modelForm.taxAmount))
		},
		'modelForm.taxAmount'() {
			this.setTaxAmount(this.modelForm.taxAmount)
		},
		'modelForm.tax.percent'() {
			this.setTaxPercent(this.modelForm.tax.percent)
		},
		'bonusSumAmount'() {
			this.calculateTotalPrice()
		},
		'modelForm.discounts'() {
			if (this.modelForm.discounts.length > 0) {
				this.modelForm.hasDiscount = false
			}
			this.setIsDisabledManuallyDiscount(this.modelForm.discounts.length > 0)
		},
		'modelForm.hasDiscount'() {
			if (!this.modelForm.hasDiscount) {
				this.bonusSumAmount = 0
				this.modelForm.bonusSumAmount = 0
				this.checkForDiscount()
			}
		}
	},
	mounted() {
		this.weekday = this.weekdays[new Date().getDay()]
		this.today = this.getTodayDate()
		this.modelForm.repaymentDate = this.getTodayDate()
		this.$root.showOverlay = true

        this
            .fetchAllProductsInWarehouses()
            .then(() => {
                this.makeName()
                this.clearInfoFromReceipt()
                this.fetchAllTaxes()
                    .then(() => {
                        this.modelForm.tax = this.getUserCompany.tax
                        this.modelForm.isTaxInPrice = this.getUserCompany.isTaxInPrice

                        this.fetchAllDiscounts({page: null, isSalePage: true})
                            .then(() => {
                                this.fetchAllServices()
                                    .then(() => {
                                        this.hasServices = this.getServices.length > 0

                                        this
                                            .fetchAllCustomers()
                                            .then(() => {
                                                this.afterFetchCustomer(this.getCustomers)
                                                this.$root.showOverlay = false

                                                this.isNeedIntegration = this.getIntegrationState
                                            })
                                    })
                            })
                    })
			})

        if (this.$route.name === "sales/edit") {
            this.$root.showOverlay = true

            this.fetchSale(this.$route.params.id)
                .then((response) => {
                    this.modelForm.isPayed = !!(response.isCanceled && response.transaction === null)
                    this.isCanceled = response.isCanceled

                    this.modelForm.bonusPercentAmount = parseFloat(response.bonusPercentAmount)
                    this.modelForm.bonusSumAmount = parseFloat(response.bonusPercentAmount)
                    this.modelForm.discountPercent = response.discountPercent

                    response.discount.map(d => {
                        this.modelForm.discounts.push(d.discount)
                    })

                    this.modelForm.customerId = response.customer.id

                    response.saleServices.map((saleService) => {
                        for (let service of this.getServices) {
                            if (saleService.service.id === service.id) {
                                this.addService(service)
                            }
                        }
                    })

                    response.saleProducts.map((soldProduct) => {
                        let wholeProduct = this.getSoldProductsInWarehouses.length > 0 ? this.getSoldProductsInWarehouses : this.getProductsInWarehouses;

                        if (soldProduct.amount !== "0.0000") {
                            let saleProduct = wholeProduct.find((productInWarehouse) => {
                                if (productInWarehouse.product.id === soldProduct.product.id) {
                                    productInWarehouse.quantity = parseFloat(soldProduct.amount)
                                    productInWarehouse.addQuantity = 0
                                    if (productInWarehouse.product.additionalUnitOfMeasures.length > 0) {
                                        productInWarehouse.product.additionalUnitOfMeasures.forEach((unit) => {
                                            unit.quantity = 0
                                        })
                                    }

                                    return productInWarehouse
                                }
                            })

                            if (saleProduct === undefined) {
                                this
                                    .fetchSoldOutProductsInWarehouses()
                                    .then(() => {
                                        saleProduct = this.getSoldProductsInWarehouses.find((productInWarehouse) => {
                                            if (productInWarehouse.product.id === soldProduct.product.id) {
                                                productInWarehouse.quantity = parseFloat(soldProduct.amount)
                                                productInWarehouse.addQuantity = 0
                                                if (productInWarehouse.product.additionalUnitOfMeasures.length > 0) {
                                                    productInWarehouse.product.additionalUnitOfMeasures.forEach((unit) => {
                                                        unit.quantity = 0
                                                    })
                                                }

                                                return productInWarehouse
                                            }
                                        })

                                        saleProduct.productInWarehouse = saleProduct['@id']
                                        saleProduct.price = response.payedAmount
                                        this.modelForm.saleId = response.id
                                        this.modelForm.company = response.company
                                        this.modelForm.currency = response.currency['@id']
                                        this.modelForm.customer = response.customer['@id']
                                        this.modelForm.payedAmount = parseFloat(response.payedAmount)

                                        if (response.isDraft) {
                                            this.modelForm.isDraft = true
                                            this.modelForm.isPayed = !!(response.transaction)
                                        }

                                        this.modelForm.saleProductDtos.push(saleProduct)
                                    })
                            } else {
                                saleProduct.productInWarehouse = saleProduct['@id']
                                saleProduct.price = response.payedAmount
                                this.modelForm.saleId = response.id
                                this.modelForm.company = response.company
                                this.modelForm.currency = response.currency['@id']
                                this.modelForm.customer = response.customer['@id']
                                this.modelForm.payedAmount = parseFloat(response.payedAmount)

                                if (response.isDraft) {
                                    this.modelForm.isDraft = true
                                    this.modelForm.isPayed = !!(response.transaction)
                                }

                                this.modelForm.saleProductDtos.push(saleProduct)
                            }
                        }
                    })

                    this.checkForDiscount()
                })

            this.$root.showOverlay = false
        }
	},
	beforeDestroy() {
		this.$root.showOverlay = false
		clearInterval(this.interval)
	},
	created() {
		this.$barcodeScanner.init(this.onBarcodeScanned)
		this.setBreadcrumbItems(this.breadcrumbItems)
	},
	destroyed() {
		this.$barcodeScanner.destroy()
	},
	beforeRouteLeave(to, from, next) {
		if (this.modelForm.saleProductDtos.length > 0 && to.name !== 'sales/transaction/check' && to.name !== 'sales/draftSales'
		) {
			this.modalText = this.$t('beforeLeaveAdvice')
			this.$bvModal.show('modal_router')
			this.next = next
		} else {
			next()
		}
	},
}
</script>

<style scoped>

.text-light span {
	font-size: 12px;
}

table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

.product-card > span {
	display: flex;
	justify-content: center;
	justify-self: center;
	margin-top: 6px;
}

</style>
